import { render, staticRenderFns } from "./index.page.vue?vue&type=template&id=22fea875&scoped=true"
import script from "./index.page.vue?vue&type=script&lang=js"
export * from "./index.page.vue?vue&type=script&lang=js"
import style0 from "./index.page.vue?vue&type=style&index=0&id=22fea875&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22fea875",
  null
  
)

export default component.exports